import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=41c8ff24&scoped=true&"
import script from "./dynamicDetail.vue?vue&type=script&lang=js&"
export * from "./dynamicDetail.vue?vue&type=script&lang=js&"
import style0 from "./dynamicDetail.vue?vue&type=style&index=0&id=41c8ff24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8ff24",
  null
  
)

export default component.exports